import resume from '../assets/pdf/resume.pdf'
export const headerData = {
    name: 'Mohamed Elsayed',
    title: "Web Developer",
    desciption:"Welcome to my digital space! I specialize in handcrafting elegant solutions for the web. Passionate about exploring new technologies, I’m here to share my work and ideas with you. Enjoy your visit!",
    image: 'Elsayed.png',
    resumePdf: resume,
    logo: 'MO.Elsayed'
}
